var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0006 12C20.0575 12 12 20.0575 12 30.0006C12 39.9401 20.0575 47.9952 30.0006 47.9952C39.9413 47.9952 48 39.9389 48 30.0006C48.0012 20.0575 39.9413 12 30.0006 12Z",
    fill: "#E3007F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9332 29.294L28.4579 23.86C28.1836 23.6612 27.8194 23.6312 27.5187 23.7858C27.2156 23.9391 27.0264 24.2506 27.0264 24.5872V35.4515C27.0264 35.7918 27.2156 36.102 27.5187 36.2554C27.6469 36.3201 27.7871 36.3524 27.9284 36.3524C28.1129 36.3524 28.2998 36.2937 28.4579 36.1775L35.9332 30.7483C36.1692 30.5746 36.307 30.3063 36.307 30.0212C36.3082 29.7313 36.1668 29.4641 35.9332 29.294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/play-video.f775f52fac3ae47fd9c4560f1109d0ad.svg";
export { ForwardRef as ReactComponent };